package mapsearch.buildings

import apiclient.geoobjects.pointCoordinates
import com.jillesvangurp.geo.tiles.Tile
import com.jillesvangurp.geo.tiles.parentTiles
import com.jillesvangurp.geo.tiles.tiles
import com.jillesvangurp.geojson.boundingBox
import dev.fritz2.core.RootStore
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.async
import kotlinx.coroutines.awaitAll
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock
import model.Building
import workspacetools.buildingeditor.boundingBox
import workspacetools.buildingeditor.mergeBoundingBoxes
import workspacetools.buildingeditor.toImageLocation

class BuildingTilesLookup : RootStore<Map<Tile, Set<String>>>(emptyMap(), Job()) {

//    fun add(buildings: Map<String, Building>, maxZoom: Int = 22) {
//        val tileMap = mutableMapOf<Tile, Set<String>>()
//
//        buildings.forEach { (id, building) ->
//            val tileWithBuildingAtMaxZoom = building.geoObjectDetails.latLon.tile(maxZoom)
//            val allTiles = (tileWithBuildingAtMaxZoom.parentTiles() + tileWithBuildingAtMaxZoom)
//            console.log("Building Tiles for ${building.buildingName}:", allTiles.map { it.path })
//            allTiles.map { tile ->
//                tileMap[tile] = tileMap[tile].orEmpty() + id
//            }
//        }
//        update(tileMap)
//    }

    fun reset() {
        update(emptyMap())
    }

    suspend fun add(buildings: Map<String, Building>) {
        update(current.toMutableMap().findAndAddTilesForBuilding(buildings))
    }

    private suspend fun MutableMap<Tile, Set<String>>.findAndAddTilesForBuilding(
        buildings: Map<String, Building>, maxZoom: Int = 22
    ): MutableMap<Tile, Set<String>> {
//        console.log("Building 0 => findAndAddTilesForBuildingBBoxAi called -> add Buildings (${buildings.size})")
        val tileMap = this
        val mutex = Mutex()

        coroutineScope {
            buildings.entries.chunked(10).map { chunk ->
                async(Dispatchers.Default) {
                    chunk.forEach { (id, building) ->
                        // get tiles for combined bBox, around all floors of the building
                        (building.floorData?.values?.flatten()?.flatMap { floor ->
                            (floor.floor.toImageLocation()?.boundingBox?.let { listOf(it) }
                                ?: floor.units?.mapNotNull { it.geometry?.boundingBox() }
                                ).orEmpty()
                        }?.ifEmpty { null }?.let { bBoxes ->
                            val tiles = mergeBoundingBoxes(bBoxes).tiles(maxZoom).flatMap { it.parentTiles().toSet() + it }
//                            if (tiles.isNotEmpty()) {
//                                console.log("Building ${building.buildingName} =>  got tiles from building & floors surrounding bBox", tiles.map { it.path })
//                            }
                            tiles
                        }?.ifEmpty { null } ?: run {
                            // fallback to tiles from building latLon position,
                            // if bBox did not generate any tiles
                            val tiles = building.geoObjectDetails.latLon.pointCoordinates().tiles()
//                            console.log("Building ${building.buildingName} =>  got tiles from buildings latLon position (fallback)", tiles.map { it.path })
                            tiles
                        }).forEach { tile ->
                            mutex.withLock {
                                tileMap[tile] = tileMap[tile].orEmpty() + id
                            }
                        }

                    }
                }
            }.awaitAll()
        }
//        console.log("Building E => tileMap -> ", tileMap)
        return tileMap
    }


    suspend fun updateBuildingInTileLookUp(building: Building) {
        // find all required tiles for the new generalMarker @ latLon
        val requiredTiles = mutableMapOf<Tile, Set<String>>().findAndAddTilesForBuilding(
            buildings = mapOf(building.buildingId to building),
            maxZoom = 22,
        ).keys.toMutableSet()

        val updatedTileMap = current.toMutableMap()

        current.keys.forEach { tile ->
            if (tile in requiredTiles) {
                // add id to existing required tile
                updatedTileMap[tile] = updatedTileMap[tile].orEmpty() + building.buildingId
                // then remove this tile from required tiles
                requiredTiles.remove(tile)
            } else if (updatedTileMap[tile]?.contains(building.buildingId) == true) {
                // remove id from not required tile
                updatedTileMap[tile] = updatedTileMap[tile].orEmpty() - building.buildingId
                // and remove not required tile if it is now empty
                if (updatedTileMap[tile].isNullOrEmpty()) {
                    updatedTileMap.remove(tile)
                }
            }
        }.also {
            // add remaining required tiles
            requiredTiles.forEach { remainingTile ->
                updatedTileMap[remainingTile] = setOf(building.buildingId)
            }
        }.also {
            update(updatedTileMap)
        }
    }
}
